 $(document).ready(function($) {
  $('.shop-online').click(function() {
    // $(this).toggleClass('active').siblings().removeClass('active');
     $(this).parent('.collapsible-block').toggleClass('active');
  });

  $('.accordion__label').click(function(event) {
    event.stopPropagation(); 
    $(this).parent('.collapsible__panel').toggleClass('active').closest('.shopify-section').siblings().find('.collapsible__panel').removeClass('active');
  });
    
    var accordionParentClass = '.eachFaq';
    var accordionQuestionClass = '.eachFaq .eachFaq-title';
    var accordionContentClass = '.accordion-content';
  
    $(accordionParentClass).each(function() {
      $( this ).addClass('close');
      $( this ).find(accordionContentClass).hide();
    });
    
    $(accordionQuestionClass).click(function(){
      var faqClass = $(this).closest(accordionParentClass).attr('class');
		console.log(faqClass);
      
      if(faqClass.indexOf('close') != -1){
        //WHEN CLOSED
        $(accordionParentClass).find(accordionContentClass).slideUp('slow'); //CLOSE ALL
        $(accordionParentClass).addClass('close').removeClass('open'); //set all faq as closed
        
        $(this).closest(accordionParentClass).removeClass('close');
        $(this).closest(accordionParentClass).addClass('open');
        $( this ).closest(accordionParentClass).find(accordionContentClass).slideDown('slow');
        
      } else {
        $(this).closest(accordionParentClass).addClass('close');
        $(this).closest(accordionParentClass).removeClass('open');
        $( this ).closest(accordionParentClass).find(accordionContentClass).slideUp('slow');
      }
      
    });
    


// size guide js

    // Open the popup
    $("#sizeGuideBtn").click(function() {
      $("#sizeGuidePopup").fadeIn();
    });

    // Close the popup when the close button is clicked
    $(".close-btn").click(function() {
      $("#sizeGuidePopup").fadeOut();
    });

    // Close the popup when clicking outside the popup content
    $(window).click(function(event) {
      if ($(event.target).is("#sizeGuidePopup")) {
        $("#sizeGuidePopup").fadeOut();
      }
    });


////////////// top or Bottom js In Product page

// $(document).ready(function() {
//   var lastTopSelected = $('.topappend:checked');
//   var lastBottomSelected = $('.bottomappend:checked');

//   // Toggle selection for top variant
//   $('.topappend').click(function() {
//     if (lastTopSelected && lastTopSelected[0] === $(this)[0]) {
//       $(this).prop('checked', false).removeClass('selected');
//       lastTopSelected = null;
//     } else {
//       if (lastTopSelected) {
//         lastTopSelected.removeClass('selected');
//       }
//       lastTopSelected = $(this).addClass('selected');
//     }
//     updateMainPrice();
//     handleSoldOutVariant($(this));
//   });

//   // Toggle selection for bottom variant
//   $('.bottomappend').click(function() {
//     if (lastBottomSelected && lastBottomSelected[0] === $(this)[0]) {
//       $(this).prop('checked', false).removeClass('selected');
//       lastBottomSelected = null;
//     } else {
//       if (lastBottomSelected) {
//         lastBottomSelected.removeClass('selected');
//       }
//       lastBottomSelected = $(this).addClass('selected');
//     }
//     updateMainPrice();
//     handleSoldOutVariant($(this));
//   });

//   function updateMainPrice() {
//     var topPriceAttr = lastTopSelected ? lastTopSelected.data('top-product-price') : '';
//     var bottomPriceAttr = lastBottomSelected ? lastBottomSelected.data('product-price') : '';

//     var topPriceNumeric = parseFloat(topPriceAttr.replace(/[^\d,-.]/g, '').replace(',', '.'));
//     var topPrice = !isNaN(topPriceNumeric) ? topPriceNumeric : 0;

//     var bottomPriceNumeric = parseFloat(bottomPriceAttr.replace(/[^\d,-.]/g, '').replace(',', '.'));
//     var bottomPrice = !isNaN(bottomPriceNumeric) ? bottomPriceNumeric : 0;

//     var totalPrice = topPrice + bottomPrice;

//     var mainPriceFormat = $('.price-item[data-main-price]').attr('data-main-price');
//     var currencySymbol = mainPriceFormat.match(/^[^\d,-]+/)[0].trim();
//     var currencyCodeMatch = mainPriceFormat.match(/[^\d,-]+$/);
//     var currencyCode = currencyCodeMatch ? currencyCodeMatch[0].trim() : '';

//     var formattedPrice = currencyCode 
//         ? currencySymbol + ' ' + totalPrice.toFixed(2).replace('.', ',') + ' ' + currencyCode
//         : currencySymbol + ' ' + totalPrice.toFixed(2).replace('.', ',');

//     if (!lastTopSelected && !lastBottomSelected) {
//         $('.price-item[data-main-price]').text(currencyCode 
//             ? currencySymbol + ' 0,00 ' + currencyCode 
//             : currencySymbol + ' 0,00');
//     } else {
//         $('.price-item[data-main-price]').text(formattedPrice);
//     }
//   }

//   function addToCart() {
//     var topSelect = lastTopSelected;
//     var bottomSelect = lastBottomSelected;
//     var topVariantId = topSelect ? topSelect.val() : null;
//     var bottomVariantId = bottomSelect ? bottomSelect.val() : null;
//     var topVariantLabel = topSelect ? $('label[for="' + topVariantId + '"]').text().trim() : '';
//     var bottomVariantLabel = bottomSelect ? $('label[for="' + bottomVariantId + '"]').text().trim() : '';
    
//     var featuredImg = $('#custom-product-add').attr('featured_img');

//     var formData = {
//       'items': []
//     };

//     if (topVariantId) {
//       formData.items.push({
//         'id': topVariantId,
//         'quantity': 1,
//         'properties': {
//           'Featured Image': featuredImg
//         }
//       });
//     }

//     if (bottomVariantId) {
//       formData.items.push({
//         'id': bottomVariantId,
//         'quantity': 1,
//         'properties': {
//           'Featured Image': featuredImg
//         }
//       });
//     }

//     if (formData.items.length === 0) {
//       alert('Please select at least one variant (Top or Bottom).');
//       return;
//     }

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       return response.json();
//     })
//     .then(data => {
//       var message = 'Item(s) added to cart:\n';
//       if (topVariantLabel) {
//         message += 'Top: ' + topVariantLabel + '\n';
//       }
//       if (bottomVariantLabel) {
//         message += 'Bottom: ' + bottomVariantLabel + '\n';
//       }

//       $.getJSON('/cart.js', function(cart) {
//         var totalItemCount = 0; 
//         cart.items.forEach(function(item) {
//           totalItemCount += item.quantity;
//         }); 
//         console.log('Total items in cart:', totalItemCount);
//         $('a#cart-icon-bubble .cart-count-bubble span').text(totalItemCount);
//       });

//       window.location.href = '/cart';
//     })
//     .catch((error) => {
//       console.error('There was a problem with the fetch operation:', error);
//       alert('There was a problem adding items to the cart. Please try again.');
//     });
//   }

//   $('#custom-product-add').click(function(event) {
//     event.preventDefault();
//     addToCart();
//     openCardDrawer();
//   });

//   // Check for sold-out or disabled variants on page load
//   function selectAvailableVariant(selector) {
//     var variants = $(selector);
//     var firstAvailableSelected = false;
//     variants.each(function() {
//       if (!$(this).hasClass('sold_out') && !$(this).prop('disabled')) {
//         if (!firstAvailableSelected) {
//           $(this).prop('checked', true).addClass('selected');
//           if (selector.includes('topappend')) {
//             lastTopSelected = $(this);
//           } else if (selector.includes('bottomappend')) {
//             lastBottomSelected = $(this);
//           }
//           firstAvailableSelected = true; // Mark that we've selected the first available variant
//         } else {
//           $(this).prop('checked', false).removeClass('selected');
//         }
//       }
//     });
//     updateMainPrice(); // Update the main price after selecting a variant
//   }

//   // Append button for sold-out variants to the nearest .custom_variants
//   function handleSoldOutVariant(element) {
//     var nearestCustomVariants = element.closest('.custom_variants');
//     if (element.hasClass('sold_out')) {
//       if (!nearestCustomVariants.find('.klaviyo_form_trigger').length) {
//         nearestCustomVariants.append('<button class="klaviyo_form_trigger">Notify Me When Available</button>');
        
//         // Add event listener after appending the button
//         nearestCustomVariants.find('.klaviyo_form_trigger').on('click', function () {
//           var legendText = $(this).closest('fieldset').find('legend').attr('title'); 
//           console.log(legendText); 
//           setTimeout(function(){
//             $('.needsclick.kl-private-reset-css-Xuajs1 input[type="text"]').val(legendText);
//           }, 1000);
//          //// duplicate
//             //window._klOnsite = window._klOnsite || [];
//             //window._klOnsite.push(['openForm', 'XQApjE']);
//           /// live
//             window._klOnsite = window._klOnsite || [];
//             window._klOnsite.push(['openForm', 'UgjCpz']);
//         });
//       }
//     } else {
//       nearestCustomVariants.find('.klaviyo_form_trigger').remove();
//     }
//   }

//   // Run selectAvailableVariant after all resources are loaded
//   $(window).on('load', function() {
//     selectAvailableVariant('.topappend');
//     selectAvailableVariant('.bottomappend');
//   });
// });

///////////////// Top and Bottom Items With default image ///////////////////
$(document).ready(function() {
  var lastTopSelected = $('.topappend:checked');
  var lastBottomSelected = $('.bottomappend:checked');

  // Function to show error message
  function showError(message) {
    var errorElement = $('<div class="error-message" style="color: red; margin-bottom: 10px;">' + message + '</div>');
    $('#custom-product-add').before(errorElement);
    setTimeout(function() {
      errorElement.fadeOut(function() {
        $(this).remove();
      });
    }, 5000);
  }

  // Toggle selection for top variant
  $('.topappend').click(function() {
    if (lastTopSelected && lastTopSelected[0] === $(this)[0]) {
      $(this).prop('checked', false).removeClass('selected');
      lastTopSelected = null;
    } else {
      if (lastTopSelected) {
        lastTopSelected.removeClass('selected');
      }
      lastTopSelected = $(this).addClass('selected');
    }
    updateMainPrice();
    handleSoldOutVariant($(this));
    $('.error-message').remove(); // Remove error message on correct selection
  });

  // Toggle selection for bottom variant
  $('.bottomappend').click(function() {
    if (lastBottomSelected && lastBottomSelected[0] === $(this)[0]) {
      $(this).prop('checked', false).removeClass('selected');
      lastBottomSelected = null;
    } else {
      if (lastBottomSelected) {
        lastBottomSelected.removeClass('selected');
      }
      lastBottomSelected = $(this).addClass('selected');
    }
    updateMainPrice();
    handleSoldOutVariant($(this));
    $('.error-message').remove(); // Remove error message on correct selection
  });

function updateMainPrice() {
    // Get top and bottom price attributes
    var topPriceAttr = lastTopSelected ? lastTopSelected.data('top-product-price') : '';
    var bottomPriceAttr = lastBottomSelected ? lastBottomSelected.data('product-price') : '';

    // Function to parse prices as integers
    function parsePrice(price) {
        // Normalize the price string by removing spaces
        price = price.replace(/\s/g, ''); // Remove spaces

        if (!price) return 0; // Return 0 for empty prices

        // Remove commas and dots
        price = price.replace(/,/g, ''); // Remove all commas
        price = price.replace(/\./g, ''); // Remove all dots

        // Convert to integer
        return parseInt(price, 10) || 0; // Parse as integer, default to 0
    }

    // Function to format price as decimal
    function formatPriceAsDecimal(price) {
        // Convert price to float and format with two decimal places
        return (price / 100).toFixed(2); // Divide by 100 and fix to 2 decimal places
    }

    // Parse the prices
    var topPriceNumeric = parsePrice(topPriceAttr);
    var bottomPriceNumeric = parsePrice(bottomPriceAttr);

    // Calculate total price
    var totalPrice = topPriceNumeric + bottomPriceNumeric;

    // Format total price with two decimal places
    var formattedPrice = formatPriceAsDecimal(totalPrice);

    // Get currency format from the main price element
    var mainPriceFormat = $('.price-item[data-main-price]').attr('data-main-price');
    var currencySymbol = mainPriceFormat.match(/^[^\d,-]+/)[0].trim();
    var currencyCodeMatch = mainPriceFormat.match(/[^\d,-]+$/);
    var currencyCode = currencyCodeMatch ? currencyCodeMatch[0].trim() : '';

    // Update the currency symbol spans
    $('.crcy-fst-symbol').text(currencySymbol);
    $('.crcy-lst-symbol').text(currencyCode);

    // Update the price display
    if (!lastTopSelected && !lastBottomSelected) {
        $('.price-item[data-main-price]').text('0.00'); // Display 0.00 if nothing is selected
    } else {
        $('.price-item[data-main-price]').text(formattedPrice); // Display the formatted total price
    }
}




  function addToCart() {
    var topSelect = lastTopSelected;
    var bottomSelect = lastBottomSelected;
    var topVariantId = topSelect ? topSelect.val() : null;
    var bottomVariantId = bottomSelect ? bottomSelect.val() : null;
    var topVariantLabel = topSelect ? $('label[for="' + topVariantId + '"]').text().trim() : '';
    var bottomVariantLabel = bottomSelect ? $('label[for="' + bottomVariantId + '"]').text().trim() : '';

    var featuredImg = $('#custom-product-add').attr('featured_img');
    var plink = $('#custom-product-add').attr('plink');

    var formData = {
      'items': []
    };

    if (topVariantId) {
      formData.items.push({
        'id': topVariantId,
        'quantity': 1,
        'properties': {
          'Featured Image': featuredImg,
          'Parent Item': plink
        }
      });
    }

    if (bottomVariantId) {
      formData.items.push({
        'id': bottomVariantId,
        'quantity': 1,
        'properties': {
          'Featured Image': featuredImg,
          'Parent Item': plink
        }
      });
    }

    if (formData.items.length === 0) {
      showError('Please select at least one variant (Top or Bottom).');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      var message = 'Item(s) added to cart:\n';
      if (topVariantLabel) {
        message += 'Top: ' + topVariantLabel + '\n';
      }
      if (bottomVariantLabel) {
        message += 'Bottom: ' + bottomVariantLabel + '\n';
      }

      $.getJSON('/cart.js', function(cart) {
        var totalItemCount = 0; 
        cart.items.forEach(function(item) {
          totalItemCount += item.quantity;
        }); 
        console.log('Total items in cart:', totalItemCount);
        $('a#cart-icon-bubble .cart-count-bubble span').text(totalItemCount);
      });

      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
      showError('There was a problem adding items to the cart. Please try again by select available Sizes.');
    });
  }

  $('#custom-product-add').click(function(event) {
    event.preventDefault();
    addToCart();
    openCardDrawer();
  });

  // Check for sold-out or disabled variants on page load
  function selectAvailableVariant(selector) {
    var variants = $(selector);
    var firstAvailableSelected = false;
    variants.each(function() {
      if (!$(this).hasClass('sold_out') && !$(this).prop('disabled')) {
        if (!firstAvailableSelected) {
          $(this).prop('checked', true).addClass('selected');
          if (selector.includes('topappend')) {
            lastTopSelected = $(this);
          } else if (selector.includes('bottomappend')) {
            lastBottomSelected = $(this);
          }
          firstAvailableSelected = true; // Mark that we've selected the first available variant
        } else {
          $(this).prop('checked', false).removeClass('selected');
        }
      }
    });
    updateMainPrice(); // Update the main price after selecting a variant
  }

  // Append "Notify Me When Available" for sold-out variants to the nearest .custom_variants
  // (Back-in-stock fix Sep 2026: now registers a real Klaviyo back-in-stock subscription for the exact variant)
  function handleSoldOutVariant(element) {
    var nearestCustomVariants = element.closest('.custom_variants');
    if (element.hasClass('sold_out')) {
      var variantId = element.val();
      var sizeLabel = $('label[for="' + variantId + '"]').first().text().trim();
      var partLabel = nearestCustomVariants.attr('id') === 'top-variant-selector' ? 'Top' : 'Bottom';
      var $trigger = nearestCustomVariants.find('.klaviyo_form_trigger');
      if (!$trigger.length) {
        $trigger = $('<button type="button" class="klaviyo_form_trigger">Notify Me When Available</button>');
        nearestCustomVariants.append($trigger);
      }
      $trigger.attr('data-variant-id', variantId).attr('data-variant-label', partLabel + ' - ' + sizeLabel);
    } else {
      nearestCustomVariants.find('.klaviyo_form_trigger').remove();
    }
  }

  $(document).on('click', '.custom_variants .klaviyo_form_trigger', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof window.bcOpenBisModal === 'function') {
      window.bcOpenBisModal($(this).attr('data-variant-id'), $(this).attr('data-variant-label'));
    }
  });

  // Run selectAvailableVariant after all resources are loaded
  $(window).on('load', function() {
    selectAvailableVariant('.topappend');
    selectAvailableVariant('.bottomappend');
  });
});

$(".topappend").click(function() {
      var newPrice = $(this).data('top-product-legend-price');
      // alert(newPrice); // Optional: for debugging purposes
      $('#top-product-label').text('Top ' + newPrice);
    });
  $(".bottomappend").click(function(){
    var newPrices = $(this).data('product-legend-price');
    $('#bottom-product-label').text('Bottom ' + newPrices);
 });
   




///////////////////////////////////////////////////////////////////

  // Wait until the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Select the button using its class name (or any other selector)
    const wishlistButton = document.querySelector('.spf-product-card__title ');

    // Check if the button exists
    if (wishlistButton) {
      // Add an event listener to the button
      wishlistButton.addEventListener('click', function() {
        // Get the variant ID from the data attribute
        const variantId = wishlistButton.getAttribute('data-variant-id');
        // Log the variant ID to the console
        console.log('Variant ID:', variantId);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation to attach the click event listener
    document.querySelector('.spf-product-card__title').addEventListener('click', function(event) {
      // Check if the clicked element is the Swym button
      if (event.target.closest('.swym-button.swym-add-to-wishlist-view-product')) {
        alert("The Swym button was clicked.");
      }
    });
  });

// cart drwer in aplphabet words

    var $listItems = $('.designer_submenu li');
    $listItems.sort(function(a, b) {
        var textA = $(a).find('a').text().toUpperCase();
        var textB = $(b).find('a').text().toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    $('.designer_submenu').append($listItems);

  ///////// updation
           $.getJSON('/cart.js', function(cart) {
                var totalItemCount = 0; 
                cart.items.forEach(function(item) {
                    totalItemCount += item.quantity;
                }); 
                console.log('Total items in cart:', totalItemCount);
               $('a#cart-icon-bubble .cart-count-bubble span').text(totalItemCount);
            });
  
      ////////////////////
});


///////////////// Bikini set back-in-stock pop-up (Klaviyo) - added Sep 2026 ///////////////////
(function () {
  var KLAVIYO_COMPANY_ID = 'QYgpk6';
  var modal = null;
  var currentVariantId = null;

  function injectStyles() {
    if (document.getElementById('bc-bis-styles')) return;
    var css =
      '#bc-bis-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:100000;align-items:center;justify-content:center;padding:16px;}' +
      '#bc-bis-overlay.is-open{display:flex;}' +
      '#bc-bis-modal{position:relative;background:#fff;color:#222;width:100%;max-width:420px;padding:36px 28px 28px;font-family:"Futura-Book",sans-serif;box-sizing:border-box;}' +
      '#bc-bis-modal *{font-family:"Futura-Book",sans-serif !important;box-sizing:border-box;}' +
      '#bc-bis-close{position:absolute;top:10px;right:14px;background:none;border:0;font-size:28px;line-height:1;color:#ccc;cursor:pointer;padding:0;}' +
      '#bc-bis-close:hover{color:#999;}' +
      '#bc-bis-headline{font-size:20px;margin:0 0 4px;color:#222;}' +
      '#bc-bis-variant{font-size:16px;margin:0 0 14px;color:#b060a4;}' +
      '#bc-bis-body{font-size:15px;margin:0 0 18px;line-height:1.5;color:#222;}' +
      '#bc-bis-modal label{display:block;font-size:14px;margin-bottom:6px;color:#222;}' +
      '#bc-bis-email{width:100%;padding:12px;border:1px solid #ccc;font-size:16px;margin-bottom:14px;border-radius:0;}' +
      '#bc-bis-submit{width:100%;padding:14px;background:#b060a4;color:#fff;border:0;font-size:16px;cursor:pointer;}' +
      '#bc-bis-submit[disabled]{opacity:0.6;cursor:default;}' +
      '#bc-bis-message{display:none;margin-top:14px;padding:12px;font-size:15px;}' +
      '#bc-bis-message.is-success{display:block;background:#d3efcd;color:#b060a4;}' +
      '#bc-bis-message.is-error{display:block;background:#fcd6d7;color:#C72E2F;}';
    var style = document.createElement('style');
    style.id = 'bc-bis-styles';
    style.innerHTML = css;
    document.head.appendChild(style);
  }

  function buildModal() {
    if (modal) return modal;
    injectStyles();
    var overlay = document.createElement('div');
    overlay.id = 'bc-bis-overlay';
    overlay.innerHTML =
      '<div id="bc-bis-modal" role="dialog" aria-modal="true" aria-labelledby="bc-bis-headline">' +
        '<button type="button" id="bc-bis-close" aria-label="Close">&times;</button>' +
        '<p id="bc-bis-headline"></p>' +
        '<p id="bc-bis-variant"></p>' +
        '<p id="bc-bis-body">Register to receive a notification when this item comes back in stock.</p>' +
        '<form id="bc-bis-form" novalidate>' +
          '<label for="bc-bis-email">Email</label>' +
          '<input type="email" id="bc-bis-email" name="email" autocomplete="email" required>' +
          '<button type="submit" id="bc-bis-submit">Notify me when available</button>' +
        '</form>' +
        '<div id="bc-bis-message" role="status"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('#bc-bis-close').addEventListener('click', close);
    overlay.querySelector('#bc-bis-form').addEventListener('submit', submit);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    modal = overlay;
    return modal;
  }

  function setMessage(type, text) {
    var msg = modal.querySelector('#bc-bis-message');
    msg.className = type ? 'is-' + type : '';
    msg.textContent = text || '';
  }

  function open(variantId, variantLabel) {
    if (!variantId) return;
    buildModal();
    currentVariantId = variantId;
    var titleEl = document.querySelector('.product__title h1');
    modal.querySelector('#bc-bis-headline').textContent = titleEl ? titleEl.textContent.trim() : '';
    modal.querySelector('#bc-bis-variant').textContent = variantLabel || '';
    modal.querySelector('#bc-bis-form').style.display = '';
    modal.querySelector('#bc-bis-submit').disabled = false;
    setMessage('', '');
    modal.classList.add('is-open');
    setTimeout(function () { modal.querySelector('#bc-bis-email').focus(); }, 50);
  }

  function close() {
    if (modal) modal.classList.remove('is-open');
  }

  function submit(e) {
    e.preventDefault();
    var emailInput = modal.querySelector('#bc-bis-email');
    var submitBtn = modal.querySelector('#bc-bis-submit');
    var email = (emailInput.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMessage('error', 'Please enter a valid email address.');
      return;
    }
    submitBtn.disabled = true;
    setMessage('', '');

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'accept': 'application/vnd.api+json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (res.ok) {
        modal.querySelector('#bc-bis-form').style.display = 'none';
        setMessage('success', "You're in! We'll let you know when it's back.");
      } else {
        return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ': ' + t); });
      }
    })
    .catch(function (err) {
      console.error('Back in stock subscription failed', err);
      submitBtn.disabled = false;
      setMessage('error', 'Sorry, something went wrong. Please try again.');
    });
  }

  window.bcOpenBisModal = open;
})();
